// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 5666) return "static/chunks/5666-2dab6e8cb163d597.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"5443":"ad7f724d","6350":"72a30a16"}[chunkId] || chunkId) + "." + {"4041":"a493a6e2ab19f830","5443":"9a4a56889a08a4f6","6350":"4e2010c6c4fbf9e3","7856":"f32cd5dc602215e1"}[chunkId] + ".js";
};